import { MdUnfoldMore } from "react-icons/md";

import IncomingCall from "@/components/acd/IncomingCall";
import IncomingCallToast from "@/components/acd/IncomingCall/IncomingCallToast";
import TTDialer from "@/components/acd/TTDialer";
import FinishedJobs from "@/components/app/FinishedJobs";
import Hotseat from "@/components/app/Hotseat";
import Messages from "@/components/app/Messages";
import { toggleModal } from "@/components/app/Switcher/switcherReducer";
import TTBreadcrumb from "@/components/app/TTBreadcrumb";
import TextCorrectionsModal from "@/components/TextCorrectionsModal";
import ITProblemModal from "@/components/tickets/ITProblemModal";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { sessionSelector } from "@/store/sessionReducer";

import UserProfileButton from "./UserProfileButton";

export default function TopBar() {
  const session = useAppSelector(sessionSelector);
  const { currentUser, currentCustomer, currentProject } = session;
  const dispatch = useAppDispatch();

  return (
    <div className="TT-top-bar">
      <div className="TT-top-bar-left">
        {currentCustomer && (
          <button type="button" className="TT-top-bar-switcher" onClick={() => dispatch(toggleModal())}>
            {currentCustomer.attrs?.hide_name ? (
              <div className="TT-top-bar-switcher-logo-block">
                {currentCustomer.logo?.medium && (
                  <img
                    className="TT-top-bar-switcher-logo TT-top-bar-switcher-logo-wide"
                    src={currentCustomer.logo.medium}
                    alt=""
                  />
                )}
                {currentProject && <div className="TT-top-bar-switcher-project">{currentProject.name}</div>}
              </div>
            ) : (
              <>
                {currentCustomer.logo?.medium && (
                  <img className="TT-top-bar-switcher-logo" src={currentCustomer.logo.medium} alt="" />
                )}
                <div className="TT-top-bar-switcher-text">
                  <div className="TT-top-bar-switcher-name">{currentCustomer.name}</div>
                  {currentProject && <div className="TT-top-bar-switcher-project">{currentProject.name}</div>}
                </div>
              </>
            )}
            <MdUnfoldMore className="TT-top-bar-switcher-icon" size={16} />
          </button>
        )}
      </div>

      <div className="TT-top-bar-right">
        <div className="TT-top-bar-breadcrumb">
          <TTBreadcrumb />
        </div>

        <div className="TT-top-bar-shortcuts TT-shortcuts-list">
          {!!currentUser.attrs.e164 && (
            <>
              <IncomingCall />
              <TTDialer />
            </>
          )}
          <Hotseat />
          <TextCorrectionsModal />
          <ITProblemModal />

          <FinishedJobs />
          <Messages />
        </div>

        <UserProfileButton />
      </div>

      {!!currentUser.attrs.e164 && <IncomingCallToast />}
    </div>
  );
}
